module.exports = __webpack_public_path__ + "img/remove.1cdb5892.svg";